import { z } from 'zod/v4';
export const corsoEmbeddedUiSearchParamsSchema = z
    .object({
    orderId: z.string(),
    shopNowId: z.string(),
    isGiftReturn: z.stringbool(),
    isOrderEdit: z.stringbool(),
})
    .partial();
export const cancelShopNowId = 'cancel';
//# sourceMappingURL=embeddedUI.js.map